import React from 'react';
import classnames from 'classnames';
import i18n from '../libs/i18n';

import Section from './Section.jsx';

export default class SectionCerts extends React.Component {
  render() {
    const sectionBg = require('images/certs-bg-alt.jpg');
    const certsUrl = require('images/certs.png');

    const title = i18n.translate('certs.title');

    const styles = {
      certsBox: classnames('certs-box'),
      allCerts: classnames('fa', 'fa-link'),
    };

    return (
      <Section id={'certs'} textAlign={'center'} sectionBg={sectionBg} title={title}>
        <div className={styles.certsBox}>
          <img src={certsUrl} alt={title} />
        </div>
        <p><a href="http://www.elconmegarad.com/azienda/certificazioni/" className={'emp-link'} target="_blank"><i className={styles.allCerts} aria-hidden="true"></i><span>{i18n.translate('certs.link')}</span></a></p>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionCerts.jsx
 **/